import { connect } from 'react-redux'
import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import BlueLogo from '../../assets/newblacklogo.png'
import { changePlan } from '../../actions'
import Plan from './Plan'
import './landing.css'
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSchool } from '@fortawesome/free-solid-svg-icons'

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
})
  
class Pricing extends Component {
  constructor() {
    super()
    this.setState = this.setState.bind(this)
  }

  render() {
    const { me, viewParams } = this.props
    const { query } = viewParams
    
    let buttonText = ['Get Started', "Start 7 Day Trial", "Start 7 Day Trial"]
    let buttonDisabled = [false, false, false]
    let buttonAction = [null, null, null]

    const isPro = me.plan && me.plan != '';
    if (me.user_name && !isPro) {
      buttonText[0] = 'Current Plan';
      buttonDisabled[0] = true;
    } else if (isPro && (me.plan == 'streamable-pro' || me.plan == 'basic-monthly')) {
      buttonText = ['Downgrade', "Current Plan", "Upgrade"]
      buttonAction = ['downgrade', null, 'upgrade']
      buttonDisabled[1] = true;
    } else if (isPro && (me.plan == 'streamable-business' || me.plan == 'pro-monthly')) {
      buttonText = ['Downgrade', "Downgrade", "Current Plan"]
      buttonAction = ['downgrade', 'downgrade', null];
      buttonDisabled[2] = true;
    }

    return (
      <div className="landing pricing">
        <Helmet>
          <title>Pricing - Streamable</title>
          <meta name="description" content="Sign up for a free account or upgrade to one of our paid plans."></meta>
          <link rel="canonical" href={`https://streamable.com/pricing`} />
        </Helmet>
        <nav className="navbar navbar-default" ref={r => this.navRef = r}>
          <ul className="nav navbar-nav">
            <li>
              <a href="https://streamable.com" className="nav-btn">
                <img className="logo" src={BlueLogo} role="presentation" />
              </a>
            </li>
          </ul>
          <ul className="nav navbar-nav float-right">
            <span>
              {this.props.me.user_name ? "" :
              <li>
                <Link to="/login" className="nav-btn login-btn">
                  Log In
                </Link>
                <Link to="/signup" className="nav-btn signup-btn">
                  Sign Up
                </Link>
              </li>
              }
            </span>
          </ul>
          
        </nav>
        <div className="header">
          <h1>Choose a plan.</h1>
        </div>
        <div className="plans">
          <Plan 
            title="Basic"
            cost="Free"
            items={['Inactive videos removed', 'Ads display on your videos', 'Embedded videos stream in SD', '10 minute maximum video duration']}
            action={buttonText[0]}
            disabled={buttonDisabled[0]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan(null))
                }
                browserHistory.push('/videos?alert=' + buttonAction[0])
              } else {
                browserHistory.push('/signup?signup_src=pricing')
              }
            }}
          >
          </Plan>
          <Plan title="Pro" cost={me.plan == 'basic-monthly' ? '$5' : "$9"} 
            items={['Videos stored forever', 'No ads on your videos', 'Embedded videos stream in HD', '10 minute maximum video duration']}
            action={buttonText[1]}
            disabled={buttonDisabled[1]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan('streamable-pro'))
                  browserHistory.push('/videos?alert=' + buttonAction[1])
                } else {
                  browserHistory.push('/checkout?plan=streamable-pro&src_internal=' + query.src_internal)
                }
              } else {
                browserHistory.push('/signup?plan=streamable-pro&src_internal=' + query.src_internal)
              }
            }}
          >
          </Plan>
          <Plan title="Business" cost="$29" 
            items={['Videos stored forever', 'No ads on your videos', 'Embedded videos stream in HD', '1 hour maximum video duration']}
            action={buttonText[2]}
            disabled={buttonDisabled[2]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan('streamable-business'))
                  browserHistory.push('/videos?alert=' + buttonAction[2])
                } else {
                  browserHistory.push('/checkout?plan=streamable-business&src_internal=' + query.src_internal)
                }
              } else {
                browserHistory.push('/signup?plan=streamable-business&src_internal=' + query.src_internal)
              }
            }}
          >
          </Plan>
        </div>
        <div className="faq">
        <div className="faq-question">
            Will people see ads on my videos?
          </div>
          <div className="faq-answer">
            Viewers will never see ads on your videos with the Pro or Business plans. With the free plan, ads will appear on your videos as soon as they become popular.
          </div>
          <div className="faq-question">
            How long are videos stored?
          </div>
          <div className="faq-answer">
            For paid plans, videos are only deleted upon your request. On the free plan, videos are deleted after 3 months of inactivity.
          </div>
          <div className="faq-question">
            Can I cancel my plan?
          </div>
          <div className="faq-answer">
            Yes, all of our plans are zero-commitment and can be cancelled at any time. If you decide to cancel during a 7-day trial, you won't pay anything.
          </div>
          <div className="faq-question">
            Do you offer any discounts?
          </div>
          <div className="faq-answer">
            If you are a school, nonprofit, or governmental entity, please <a href="mailto:sales@streamable.com?Subject=Discount%20request">contact us</a> for special pricing.
          </div>
          <div className="faq-question">
            What if I need a different plan?
          </div>
          <div className="faq-answer">
            Please email <a href="mailto:sales@streamable.com?Subject=Custom%20plan">sales@streamable.com</a> to set up a custom plan.
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid">
            <ul className="nav navbar-nav">
              <li>
                <a href="//privacy.streamable.com">
                  Privacy
                </a>
              </li>
              <li>
                <a href="//terms.streamable.com">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://support.streamable.com">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </footer>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Pricing)
